// extracted by mini-css-extract-plugin
module.exports = {"header":"RelatedArticles_header__HJ9xX","title":"RelatedArticles_title__SQbb0","articles":"RelatedArticles_articles__4G3xA"};